<template>
  <div id="error">
    <SfBreadcrumbs class="breadcrumbs desktop-only container-xl" :breadcrumbs="breadcrumbs">
      <template #link="{breadcrumb}">
        <router-link :to="breadcrumb.route.link" class="sf-breadcrumbs__breadcrumb">
          {{ breadcrumb.text }}
        </router-link>
      </template>
    </SfBreadcrumbs>

    <div class="container-xl">
      <MError :title="errorTitle" :subtitle="errorSubtitle" />
    </div>
  </div>
</template>

<script>
import i18n from '@vue-storefront/i18n';
import { Logger } from '@vue-storefront/core/lib/logger';
import MError from 'theme/components/molecules/m-error';

import {
  SfBreadcrumbs
} from '@storefront-ui/vue';

export default {
  name: 'Error',
  components: {
    MError,
    SfBreadcrumbs
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    errorTitle () {
      return this.$route.name === 'error'
        ? i18n.t('Something went wrong ...')
        : i18n.t("We can't find the page");
    },
    errorSubtitle () {
      return this.$route.name === 'error'
        ? i18n.t("We've noticed Internal Server Error while rendering this request.")
        : i18n.t("Unfortunately we can't find the page you are looking for.");
    },
    errorMetaTitle () {
      return this.$route.name === 'error'
        ? i18n.t('Internal Server Error 500')
        : i18n.t('404 Page Not Found');
    },
    breadcrumbs () {
      return [
        { text: i18n.t('ruckzuck.store'), route: { link: this.localizedRoute('/') } },
        { text: this.errorTitle }
      ];
    }
  },
  asyncData ({ store, route, context }) {
    return new Promise((resolve, reject) => {
      Logger.log('Calling asyncData for Error page ' + new Date())();
      if (context) {
        context.output.cacheTags.add(`error`);
      }
      resolve();
    })
  },
  metaInfo () {
    return {
      title: this.$route.meta.title || this.title || this.errorMetaTitle,
      meta: this.$route.meta.description
        ? [{ vmid: 'description', name: 'description', content: this.$route.meta.description }]
        : []
    };
  }
};
</script>
